import DOMPurify from 'dompurify';

import { TSanitizeHtml } from '../../mappers/sanitizeOffersData';

/**
 * Браузерный санитайзер HTML на DOMPurify поверх нативного DOM браузера.
 *
 * Используется только в браузерном перезапросе выдачи (thunk getOffersData). На сервере
 * за санитизацию отвечает `sanitizeHtmlNode` на sanitize-html: DOMPurify поверх jsdom
 * удерживает память на каждый вызов и замедляется по мере роста heap (см. PERFORMANCE_TTFB.MD),
 * поэтому isomorphic-dompurify и jsdom в проекте больше не используются.
 *
 * Без DOM (на ноде) DOMPurify не инициализируется, поэтому вызов там — ошибка, а не тихий пропуск.
 */
export const sanitizeHtmlBrowser: TSanitizeHtml = html => {
  if (!DOMPurify.isSupported) {
    throw new Error('sanitizeHtmlBrowser доступен только в браузере, на сервере используйте sanitizeHtmlNode');
  }

  return DOMPurify.sanitize(html);
};
